export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
              平台介绍
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              关于我们
            </h2>
          </div>

          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
            <div className="space-y-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                <strong className="text-foreground-900">酷客影院</strong>是一个专注于<strong className="text-foreground-900">高清电影</strong>与<strong className="text-foreground-900">高清电视剧</strong>在线观看的内容平台。我们致力于为追求极致观影体验的用户提供<strong className="text-foreground-900">超清播放</strong>服务，画质清晰不缓冲，让每一位影迷都能享受流畅、沉浸的观影时光。
              </p>
              <p>
                平台收录超过<strong className="text-foreground-900">20000部</strong>影视资源，覆盖院线新片、热门剧集、经典老片、高分纪录片与动画动漫等多元类型，每日持续更新50+部最新内容。
              </p>
              <p>
                我们始终坚持以用户体验为核心，持续优化播放技术与内容算法，努力成为你发现好片、享受观影的首选平台。无论你是资深影迷还是休闲观众，都能在酷客影院找到属于你的光影世界。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}